export class CongViecPagingResponse {
    "data": Array<CongViec>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class CongViec {
    "id": number;
    "noiDung": string;
    "idNVKhoiTao": number;
    "tenNhanVien": string;
    "tenDonVi": string;
    "tenChucVu": string;
    "trangThai": number;
    "ngayHoanThanh": Date;
    "thoiGianGiao": Date;
    "thoiGianYeuCauHoanThanh": Date;
    "isGiaoViec": number;
    "nhanViens": Array<NhanVien_CongViec>;
}

export class NhanVien_CongViec {
    "tenNhanVien": string;
    "tenDonVi": string;
    "idNhanVien": number;
    "idCongViec": number;
    "trangThai": number;
}